import styled from 'styled-components/macro';
import Split from 'react-split';

import { chatUI } from 'styles/featureColors/chatUIColors';
import * as colors from '../common/colorConstants';

export const Section = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const SplitSections = styled(Split)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  > .gutter {
    cursor: row-resize;
    position: relative;
    background: ${({ $chatUIOnscreen }) => ($chatUIOnscreen ? `${chatUI.toolbar.border}` : `${colors.lightGray21}`)};
    z-index: 1;
    margin-bottom: 0px;
  }
`;

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ChatHolder = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MessagesGroups = styled.div`
  flex: 1;
  min-height: 1px;
`;
